export default {
    data() {
        return {
        };
    },
    methods: {
        openModalIframe() {
            // this.$refs["modal-iframe"].toggleModal();
            window.open(this.faqUrl, '_blank');
        },
        toggleActiveIframeModalInterval() {
            this.activeIframeModalInterval = !this.activeIframeModalInterval;
        },
    },
};
